import { render, staticRenderFns } from "./configureRadio.vue?vue&type=template&id=1f51d12c&scoped=true"
import script from "./configureRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./configureRadio.vue?vue&type=script&setup=true&lang=js"
import style0 from "./configureRadio.vue?vue&type=style&index=0&id=1f51d12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f51d12c",
  null
  
)

export default component.exports